import { KaskoProceed } from "./kasko-proceed";

export class Kasko {
  constructor(
    private _id: string,
    private _serviceNumber: string,
    private _serviceType: string,
    private _idCustomer: string,
    private _idPayment: string,
    private _idInvoice: number,
    private _idPdfInvoice: string,
    private _state: KaskoStateStep,
    private _shopId: string,
    private _agentId: string,
    private _mshpId: string,
    private _userId: string,
    private _creationDate: Date,
    private _signedPolicyUrl: string,
    private _updatedAt: Date,
    private _brand: string,
    private _model: string,
    private _purchasePhoneAmount: number,
    private _totalAmount: number,
    private _totalAmountVat: number,
    private _proceeds: KaskoProceed,
    private _imei: string,
    private _imgReceiptUrl: string,
    private _note: string,
    private _purchaseDate: string, // DD/MM/YYYY
    private _warranty: string,
    private _expiredAt: Date = null,
    private _startFrom: Date = null,
    private _completed: boolean = false,
    private _posAmount: string = undefined,
    private _rateAmount: string = undefined,
    private _telcoOrderId: string = undefined,
  ) {}

  get id(): string {
    return this._id;
  }

  get serviceNumber(): string {
    return this._serviceNumber;
  }

  get serviceType(): string {
    return this._serviceType;
  }

  get idCustomer(): string {
    return this._idCustomer;
  }

  get idPayment(): string {
    return this._idPayment;
  }

  get idInvoice(): number {
    return this._idInvoice;
  }

  get idPdfInvoice(): string {
    return this._idPdfInvoice;
  }

  get state(): KaskoStateStep {
    return this._state;
  }

  get shopId(): string {
    return this._shopId;
  }

  get agentId(): string {
    return this._agentId;
  }

  get mshpId(): string {
    return this._mshpId;
  }

  get userId(): string {
    return this._userId;
  }

  get creationDate(): Date {
    return this._creationDate;
  }

  get signedPolicyUrl(): string {
    return this._signedPolicyUrl;
  }

  get updatedAt(): Date {
    return this._updatedAt;
  }

  get brand(): string {
    return this._brand;
  }

  get model(): string {
    return this._model;
  }


  get purchasePhoneAmount(): number {
    return this._purchasePhoneAmount;
  }

  get totalAmount(): number {
    return this._totalAmount;
  }

  get totalAmountVat(): number {
    return this._totalAmountVat;
  }

  get proceeds(): KaskoProceed {
    return this._proceeds;
  }

  get imei(): string {
    return this._imei;
  }

  get imgReceiptUrl(): string {
    return this._imgReceiptUrl;
  }

  get note(): string {
    return this._note;
  }

  get purchaseDate(): string {
    return this._purchaseDate;
  }

  get warranty(): string {
    return this._warranty;
  }

  set startFrom(value: Date) {
    this._startFrom = value;
  }

  get startFrom(): Date {
    return this._startFrom;
  }

  set expiredAt(value: Date) {
    this._expiredAt = value;
  }

  get expiredAt(): Date {
    return this._expiredAt;
  }

  get completed(): boolean {
    return this._completed;
  }

  get posAmount(): string {
    return this._posAmount;
  }

  get rateAmount(): string {
    return this._rateAmount;
  }

  get telcoOrderId(): string {
    return this._telcoOrderId;
  }

  set completed(value: boolean) {
    this._completed = value;
  }

  set posAmount(value: string) {
    this._posAmount = value;
  }

  set rateAmount(value: string) {
    this._rateAmount = value;
  }

  set telcoOrderId(value: string) {
    this._telcoOrderId = value;
  }

  static fromRaw(kaskoRaw): Kasko {
    console.log("kaskoRaw", kaskoRaw);
    const kasko = new Kasko(
      kaskoRaw.key,
      kaskoRaw.data.service_number,
      kaskoRaw.data.service_type,
      kaskoRaw.data.id_customer,
      kaskoRaw.data.id_payment,
      kaskoRaw.data.id_invoice,
      kaskoRaw.data.id_pdf_invoice,
      kaskoRaw.data.state,
      kaskoRaw.data.shop_id,
      kaskoRaw.data.agent_id,
      kaskoRaw.data.mshp_id,
      kaskoRaw.data.user_id,
      new Date(kaskoRaw.data.creation_date._seconds * 1000),
      kaskoRaw.data.signed_policy_url,
      new Date(kaskoRaw.data.updated_at._seconds * 1000),
      kaskoRaw.data.brand,
      kaskoRaw.data.model,
      kaskoRaw.data.purchase_phone_amount,
      kaskoRaw.data.total_amount,
      kaskoRaw.data.total_amount_vat,
      KaskoProceed.fromRaw(kaskoRaw.data.proceeds),
      kaskoRaw.data.imei,
      kaskoRaw.data.img_receipt_url,
      kaskoRaw.data.note,
      kaskoRaw.data.purchase_date,
      kaskoRaw.data.warranty,
    );
    if (kaskoRaw.data.expired_at) {
      kasko.expiredAt = new Date(kaskoRaw.data.expired_at._seconds * 1000);
    }

    if (kaskoRaw.data.rate) {
      kasko.posAmount = kaskoRaw.data.rate.posAmount;
      kasko.rateAmount = kaskoRaw.data.rate.rateAmount;
    }
    
    if (kaskoRaw.data.start_from) {
      kasko.startFrom = new Date(kaskoRaw.data.start_from._seconds * 1000);
    }

    if (kaskoRaw.data.completed) {
      kasko.completed = kaskoRaw.data.completed;
    }

    if (kaskoRaw.data.telcoOrderId) {
      kasko.telcoOrderId = kaskoRaw.data.telcoOrderId;
    }

    return kasko;
  }
}

export enum KaskoStateStep {
  Creato = "creato",
  Rifiutato = "rifiutato", // update req `state`
  Accettato = "accettato", // update req `state`
  InfoInserite = "info inserite",
  ClienteInserito = "cliente inserito", // update `id_customer` & state
  PagamentoEffettuato = "pagamento effettuato", // update `id_payment` & state
  InAttesaDiAttivazione = "in attesa di attivazine",
  Attiva = "attiva",
  Scaduta = "scaduta",
}



// WEBPACK FOOTER //
// ./src/app/core/model/kasko.ts